import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=5c833af0&"
import script from "./HeaderComponent.vue?vue&type=script&lang=ts&"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c833af0')) {
      api.createRecord('5c833af0', component.options)
    } else {
      api.reload('5c833af0', component.options)
    }
    module.hot.accept("./HeaderComponent.vue?vue&type=template&id=5c833af0&", function () {
      api.rerender('5c833af0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderComponent.vue"
export default component.exports